module.exports = __webpack_public_path__ + "static/img/5.840ce12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/5.jpg
// module id = hiUG
// module chunks = 16